import { CouncilParticipant, Society, SocietyDirector } from 'types';

export const getDirectorFromParticipant = (
  participant: CouncilParticipant,
  actualSociety: Society
): SocietyDirector | undefined =>
  actualSociety?.directors.find(
    (director) => director._id === participant.member
  );
